(function () {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-atn-reveal]').forEach(function (el) {
      el.classList.add('atn-in');
    });
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('atn-in');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.25 }
  );

  function observeAll() {
    document.querySelectorAll('[data-atn-reveal]:not(.atn-in)').forEach(function (el) {
      io.observe(el);
    });
  }

  observeAll();
  document.addEventListener('shopify:section:load', observeAll);
})();
